/**
 * REST paths relative to REACT_APP_AI_CHAT_API_BASE (e.g. http://localhost:3001/api/v1).
 * Use this base for optional chatbot/experimental routes — not for DDV core
 * GET/POST /project/settings/:id (see projectInfo.api / projects.api).
 */

export const chatbotAgentsPath = () => '/chatbot/agents';

export const chatbotAgentByIdPath = (id) =>
  `/chatbot/agents/${encodeURIComponent(id)}`;

export const chatbotConfigByModuleId = (moduleId) =>
  `/chatbot/config/${encodeURIComponent(moduleId)}`;

export const chatbotConfigPath = () => '/chatbot/config';

/** SSE conversation POST (body: message, conversationId, settings). */
export const chatbotConversationPath = () => '/chatbot';

/** Short-lived WebSocket ticket (GET returns { chatId }). */
export const chatbotChatIdPath = () => '/chatbot/chat-id';

/** Runtime audience list for who may see AI chat on this module (GET returns string[]). */
export const chatbotVisibilityByModuleId = (moduleId) =>
  `/chatbot/visibility/${encodeURIComponent(moduleId)}`;

/** Opt-in REST completions; DDV API does not ship this route by default. */
export const projectAiChatMessagePath = (projectId) =>
  `/projects/${encodeURIComponent(projectId)}/ai-chat/messages`;
